import { render } from "./InstanceCreationScreen.vue?vue&type=template&id=18a342cf&scoped=true"
import script from "./InstanceCreationScreen.vue?vue&type=script&lang=js"
export * from "./InstanceCreationScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=18a342cf&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a342cf"]])

export default __exports__